import {
    ADD_COURIER_REQUEST,
    ADD_COURIER_SUCCESS,
    ADD_COURIER_FAILURE,
} from "../actions";

const initialState = {
    loading: false,
    data: [],
    error: "",
};

const addCourierListByAdminReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_COURIER_REQUEST:
            return {
                ...state,
                loading: true,
                data: [],
            };

        case ADD_COURIER_SUCCESS:
            return {
                loading: false,
                data: action.payload,
                error: "",
            };
        case ADD_COURIER_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };
        default:
            return state;
    }
};
export default addCourierListByAdminReducer;
